import axios from './httpClient';
import { getAccessToken } from './accessToken';



export async function getCustomerProfile(IdUser, instance, accounts) {
  const accessToken = await getAccessToken(instance, accounts);

  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };
  return axios

    .get(`${process.env.REACT_APP_API_URL}/customers/${IdUser}`, config)
    .then((res) => res.data.data);
}
